// src/services/taskService.js
import axiosInstance from "../axiosInstace";

// Build a valid task payload from a single quick-add row
export function buildTaskPayload(row, context) {
  return {
    taskTitle: row.title.trim(),
    remark: row.remark?.trim() || "",
    schedulingMode: "DATE",
    startDate: context.startDate,
    endDate: context.endDate,
    priority: "LOW",
    projectId: context.projectId,
    stagePositionId: context.stagePositionId,
    accessId: context.accessId,
    todoRequestDTOList: [],
  };
}

// Create multiple tasks in one API call
export async function createTasks(payloadArray) {
  try {
    const response = await axiosInstance.post("/api/emp/tasks/create", payloadArray);
    return response.data; // includes { status, message, data: [...] }
  } catch (error) {
    console.error("Task creation failed:", error);
    throw error.response?.data || { message: "Failed to create tasks" };
  }
}

// Basic quick validation
export function validateTask(row) {
  if (!row.title?.trim()) {
    throw new Error("Task title is required");
  }
  return true;
}
